import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button, Glyphicon, Table } from 'react-bootstrap'
import DriverRow from './DriverRow'
import AddDriverBox from './AddDriverBox'
import { translate } from '../../../common/utils'

class DriverContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showAddSubadminBox: false,
      showAddDriverBox: false,
      sortProperty: 'name',
      sortDirection: -1,
    }
  }

  toggleAddDriver = () => {
    this.setState({ showAddDriverBox: !this.state.showAddDriverBox })
  }

  changeSort = (property) => {
    const { sortProperty, sortDirection } = this.state
    const newSortDirection = property === sortProperty ? -1 : 1

    this.setState({ sortDirection: sortDirection * newSortDirection, sortProperty: property })
  }

  render() {
    const { terminals, drivers, events, admin } = this.props

    const { sortProperty, sortDirection } = this.state

    if (!drivers || !events) return null

    const sortedDrivers = [...drivers].sort((a, b) => {
      if (sortProperty === 'last_active') {
        if (!a.last_active) return 1
        if (!b.last_active) return -1

        if (new Date(a.last_active).getTime() < new Date(b.last_active).getTime()) return sortDirection
        if (new Date(a.last_active).getTime() > new Date(b.last_active).getTime()) return sortDirection * -1
      }

      let aProp
      let bProp
      if (sortProperty === 'c_terminal') {
        const aTerminal = terminals.find((t) => t._id === a.terminal) || { company: '' }
        const bTerminal = terminals.find((t) => t._id === b.terminal) || { company: '' }

        aProp = aTerminal.company.toLowerCase()
        bProp = bTerminal.company.toLowerCase()
      } else {
        aProp = (a[sortProperty] || '').toLowerCase()
        bProp = (b[sortProperty] || '').toLowerCase()
      }

      if (!aProp) return 1
      if (!bProp) return -1

      if (aProp < bProp) {
        return sortDirection
      }
      if (aProp > bProp) {
        return sortDirection * -1
      }
      return 0
    })

    return (
      <div>
        <Button onClick={this.toggleAddDriver} className="add-lock-btn" bsSize="small" block>
          <Glyphicon glyph="glyphicon glyphicon-plus" /> &nbsp; Lägg till ny chaufför
        </Button>
        <AddDriverBox toggled={this.state.showAddDriverBox} toggleAddDriver={this.toggleAddDriver} terminals={terminals} />
        <h3 className="sub-title" style={{ marginTop: 40 }}>
          Chaufförer
        </h3>
        <Table responsive style={{ backgroundColor: 'white' }}>
          <thead>
            <tr>
              <th></th>
              <th onClick={() => this.changeSort('name')}>
                <div style={{ float: 'left' }}>{sortProperty == 'name' ? sortDirection < 0 ? <Glyphicon glyph="glyphicon glyphicon-arrow-up" /> : <Glyphicon glyph="glyphicon glyphicon-arrow-down" /> : <Glyphicon glyph="glyphicon glyphicon-sort" />}</div>Namn
              </th>
              <th>Tele.</th>
              {admin.type !== 'c_terminal' && (
                <th onClick={() => this.changeSort('c_terminal')}>
                  <div style={{ float: 'left' }}>{sortProperty == 'c_terminal' ? sortDirection < 0 ? <Glyphicon glyph="glyphicon glyphicon-arrow-up" /> : <Glyphicon glyph="glyphicon glyphicon-arrow-down" /> : <Glyphicon glyph="glyphicon glyphicon-sort" />}</div>Åkeri
                </th>
              )}
              <th onClick={() => this.changeSort('area')}>
                <div style={{ float: 'left' }}>{sortProperty == 'area' ? sortDirection < 0 ? <Glyphicon glyph="glyphicon glyphicon-arrow-up" /> : <Glyphicon glyph="glyphicon glyphicon-arrow-down" /> : <Glyphicon glyph="glyphicon glyphicon-sort" />}</div>Område
              </th>
              <th>Chaufför-id</th>
              <th onClick={() => this.changeSort('lastActive')}>
                <div style={{ float: 'left' }}>{sortProperty === 'lastActive' ? sortDirection < 0 ? <Glyphicon glyph="glyphicon glyphicon-arrow-up" /> : <Glyphicon glyph="glyphicon glyphicon-arrow-down" /> : <Glyphicon glyph="glyphicon glyphicon-sort" />}</div>Senast aktiv
              </th>
              <th onClick={() => this.changeSort('lastDeliveryAssigned')}>
                <div style={{ float: 'left' }}>{sortProperty === 'lastDeliveryAssigned' ? sortDirection < 0 ? <Glyphicon glyph="glyphicon glyphicon-arrow-up" /> : <Glyphicon glyph="glyphicon glyphicon-arrow-down" /> : <Glyphicon glyph="glyphicon glyphicon-sort" />}</div>Senast
                tilldelad access
              </th>
              {this.props.admin.user.settings && this.props.admin.user.settings.k2enabled == true ? <th>{translate('k2username')}</th> : null}
            </tr>
          </thead>
          <tbody>
            {sortedDrivers.map((driver) => (
              <DriverRow key={driver._id} driver={driver} events={events} terminals={terminals} />
            ))}
          </tbody>
        </Table>
      </div>
    )
  }
}

const mapState = (state) => ({
  events: state.collectionData.events,
  admin: state.collectionData.admin,
})

const mapDispatch = (dispatch) => ({})

export default connect(
  mapState,
  mapDispatch
)(DriverContainer)
